import * as styles from "./Slider.css";

import { clsx } from "clsx";
import { useMemo } from "react";
import type { JSX } from "react";

import { Slider as BaseSlider } from "@base-ui/react/slider";

import { SliderContext } from "./Slider.context";
import type { SliderProps } from "./Slider.types";

export function Slider<Value extends number | readonly number[] = number>({
  className,
  min = 0,
  max = 100,
  step = 1,
  orientation = "horizontal",
  children,
  ...props
}: SliderProps<Value>): JSX.Element {
  const context = useMemo(
    () => ({ min, max, step, orientation }),
    [min, max, step, orientation],
  );

  return (
    <SliderContext.Provider value={context}>
      <BaseSlider.Root
        data-slot="slider"
        className={clsx(styles.root, className)}
        min={min}
        max={max}
        step={step}
        orientation={orientation}
        {...props}
      >
        {children}
      </BaseSlider.Root>
    </SliderContext.Provider>
  );
}
